import React, { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import i18n, { LANGUAGES } from "../../i18n";
import PopupDialog from "../elements/PopupDialog/PopupDialog";
import Radio from "../elements/RadioGroup/Radio";
import RadioGroup from "../elements/RadioGroup/RadioGroup";
import "./LanguageSelectModal.scss";
import "./LanguageSelectModal_flint.scss";
import "./LanguageSelectModal_kokoro.scss";
import "./LanguageSelectModal_pdd.scss";
import "./LanguageSelectModal_shabuDays.scss";
import "./LanguageSelectModal_torikizoku.scss";
import "./LanguageSelectModal_wang.scss";

interface ILanguageSelectModalProps {
	onClose: () => void;
}

const LanguageSelectModal: FC<ILanguageSelectModalProps> = (props) => {
	const { t } = useTranslation();
	const [language, setLanguage] = useState<string>(i18n.language);

	const handleClickConfirm = () => {
		i18n.changeLanguage(language);
		props.onClose();
	};

	const renderLanguageSelections = useCallback(() => {
		return LANGUAGES.map((lang) => (
			<Radio
				value={lang.value}
				label={lang.label}
				data-testid={"LanguageModalRadio" + lang.value}
				className="LanguageSelectModalRadio"
				labelClassName="LanguageSelectModalRadioLabel"
				key={lang.value}
			/>
		));
	}, []);

	return (
		<PopupDialog
			onClose={props.onClose}
			open={true}
			content={
				<div data-testid="LanguageModalForm" className="LanguageSelectModalForm">
					<div
						id="language-modal-buttons-group-label"
						data-testid="LanguageModalLabel"
						className="LanguageSelectModalLabel"
					>
						{t("LanguageSelectionModal.choose_language")}
					</div>
					<RadioGroup
						aria-labelledby="language-modal-buttons-group-label"
						value={language}
						name="radio-buttons-group"
						onChange={(e) => setLanguage(e.target.value)}
						data-testid="LanguageModalRadioGroup"
					>
						{renderLanguageSelections()}
					</RadioGroup>
				</div>
			}
			buttons={[
				{
					text: t("LanguageSelectionModal.confirm"),
					onClick: handleClickConfirm,
					className: "BtnLanguageConfirm",
				},
			]}
			data-testid="LanguageModal"
			className="LanguageSelectModal"
		/>
	);
};

export default LanguageSelectModal;
